module.exports = __webpack_public_path__ + "static/media/how_mobile.8c6e1e12.jpeg";